import {
    Popup,
    PopupBody,
    PopupTitle,
    PopupHeader,
    PopupContent,
    PopupDescription,
} from './popover.styled'

const Popover = ({
    open,
    task,
    anchorEl,
    handlePopoverClose,
}) => {
    return (
        <Popup
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
            disableRestoreFocus
        >
            <PopupHeader>Task Information</PopupHeader>
            <PopupBody>
                <PopupContent>
                    <PopupTitle>Requirement</PopupTitle>
                    <PopupDescription>{task?.requirement || '-'}</PopupDescription>
                </PopupContent>
                <PopupContent>
                    <PopupTitle>Compliance Parameter</PopupTitle>
                    <PopupDescription>{task?.compliance_parameter || '-'}</PopupDescription>
                </PopupContent>
            </PopupBody>
        </Popup>
    )
}

export default Popover